exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auto-import-configs .v-badge__badge[data-v-38b9276c]{font-size:10px;height:18px;min-width:18px;padding:2px 4px}", ""]);

// exports
